import PropTypes from 'prop-types';
import classnames from 'classnames';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { color } from '../../../app/theme';
import defaultPNG from '../../../assets/images/png/img-default-tamplate-img@3x.png';

const useStyles = makeStyles(
  () => ({
    card: ({ width }) => ({
      flex: '0 0 auto',
      display: 'flex',
      flexDirection: 'column',
      width: width || 204,
      margin: '0 8px 0 0',
      backgroundColor: color.$7,
      borderRadius: 12,
      boxShadow: '0 8px 36px 0 rgba(0, 0, 0, 0.06)',
      '&:last-child': {
        marginRight: 0,
      },
    }),
    imageContainer: {
      width: '100%',
      borderRadius: 12,
      '& > div': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        width: '100%',
        borderRadius: '12px 12px 0 0',
        '& > img': {
          width: '100%',
          objectFit: 'cover',
          borderRadius: 12,
        },
      },
    },
    'image-type-url': {
      width: 124,
      height: 124,
    },
  }),
  {
    name: 'ImageCard',
  },
);

function ImageCard({ data, messageIndex, index, width }) {
  const classes = useStyles({ width });

  return (
    <div className={classes.card} key={`preview-${messageIndex}-card-${index}`}>
      <div className={classes.imageContainer}>
        <div>
          <img
            className={classnames({
              [classes['image-type-url']]: data.imageType === 'url',
            })}
            src={
              data.imageUrl && data.imageUrl !== '' ? data.imageUrl : defaultPNG
            }
            alt="preview"
          />
        </div>
      </div>
    </div>
  );
}

ImageCard.defaultProps = {
  width: undefined,
};

ImageCard.propTypes = {
  data: PropTypes.object.isRequired,
  messageIndex: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  width: PropTypes.number,
};

export default ImageCard;
